export default function NotFoundPage() {
  return <div className="grid place-content-center h-full">Page not found</div>;
}
